/**
 * Funnel step 2 (pet name). Button starts disabled and enables as soon as
 * the field has text. Validates on submit too (safety net), merges
 * { petName } into the shared funnel state (funnel-state.js — keeps the
 * email from step 1 intact), then redirects to the next step.
 */
(() => {
  document.querySelectorAll('[data-pet-name-form]').forEach((form) => {
    const input = form.querySelector('[data-pet-name-input]');
    const field = input.closest('.pet-name__field');
    const errorEl = form.querySelector('[data-pet-name-error]');
    const submitBtn = form.querySelector('[data-pet-name-submit]');
    const buttonLabel = form.querySelector('[data-pet-name-button-label]');
    const nextUrl = form.dataset.nextUrl || '/pages/subir-foto-mascota';

    const showError = (message) => {
      field.classList.add('has-error');
      errorEl.textContent = message;
      errorEl.hidden = false;
    };

    const clearError = () => {
      field.classList.remove('has-error');
      errorEl.hidden = true;
      errorEl.textContent = '';
    };

    // Pre-fill from a previous visit to this step (e.g. came back via the
    // header's back link) so nothing is lost.
    const existing = window.PfFunnel ? window.PfFunnel.get() : {};
    if (existing.petName) {
      input.value = existing.petName;
      submitBtn.disabled = false;
    }

    input.addEventListener('input', () => {
      clearError();
      submitBtn.disabled = input.value.trim().length === 0;
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const petName = input.value.trim();

      if (!petName) {
        showError('Merci d\'indiquer le nom de ta mascotte.');
        input.focus();
        return;
      }

      clearError();

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      if (buttonLabel) buttonLabel.textContent = 'Un instant…';

      window.PfFunnel.set({ petName });

      window.location.href = nextUrl;
    });
  });
})();
